import { css } from '@emotion/react';
import { CardWithID, TributeCardWithID } from '@mythos/game/Rules';
import { BasicCardRenderer } from './CardView';
import PileView, { PileTributeCardRenderer } from './PileView';

export function DeckView(props: { title: string; cards: CardWithID[] }) {
  return (
    <div css={DeckViewStyles.container}>
      <div css={DeckViewStyles.title}>{props.title}</div>
      <PileView
        cards={props.cards}
        renderer={BasicCardRenderer}
        hoverRenderer={BasicCardRenderer}
      />
    </div>
  );
}
export function TributeDeckView(props: {
  title: string;
  cards: TributeCardWithID[];
}) {
  return (
    <div css={DeckViewStyles.container}>
      <div css={DeckViewStyles.title}>{props.title}</div>
      <PileView
        cards={props.cards}
        renderer={PileTributeCardRenderer}
        hoverRenderer={PileTributeCardRenderer}
      />
    </div>
  );
}

const DeckViewStyles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',

    width: '70vw',
    overflowY: 'auto',
    flexShrink: 1,
  }),
  title: css({
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    alignSelf: 'center',
  }),
};
